export const siteCounterId = "site-counter";
export const siteSidebarId = "site-sidebar";

export const siteMenuTargetId = "site-menu-target";
export const siteMenuBaseId = "site-menu-base";

export const siteMobileSearchId = "site-mobile-search";
export const siteMobileMenuId = "site-mobile-menu";
export const siteAnnounceMiniId = "site-announce-mini";
export const siteAnnounceFullId = "site-announce-full";
export const siteSearchResultId = "site-search-result";
export const siteImagesId = "site-images";
export const siteReadAlsoId = "site-read-also";
export const siteArticleRatingId = "site-article-rating";
export const siteCommentItemsId = "site-comment-items";
export const siteMailFormId = "site-mail-form";
export const siteArticleIdnAttr = "data-number";
export const siteTableClassSorting = "sorting";
export const siteUserMenu = "site-user-menu";
export const siteActivityQuiz = "site-quiz";
export const siteActivityGame = "site-funny";
export const siteActivityOldGame = "funny";

export const headerUserState = "user-state";
export const headerUserKey = "user-key";

export const apiPath = "/api"; // "/api/v2"

export const imageRootPath = "/file/";

export const jsLogsPath = "/logs/";

export const siteViewTesting = "site-view-testing";
export const siteViewPrice = "site-view-price";
export const siteCatalogAdds = "site-catalog-adds";
export const siteYoutubeSrc = "data-youtube-src";
export const siteSlideShow = "site-slide-show";

export const siteMenuTypeSearch = "Search" as const;
export const siteMenuTypePrice = "Price" as const;
export const siteMenuTypePlus = "Plus" as const;
export const siteMenuTypeGames = "Games" as const;
export const siteMenuTypeMain = "Main" as const;
export const siteMenuTypeUp = "Up" as const;
export const siteMenuTypeDown = "Down";

//export const siteHtmlOverflow = "overflow";

export const mediaDesktopWidth = 1000;
export const mediaMobileWidth = 700;

export const extJson = ".json";
export const extMp3 = "mp3";
export const extMp4 = "mp4";
export const extTmp = ".tmp";
export const extWebp = ".webp";

export const linkRelSponsored = "sponsored";
export const linkRelUserContent = "ugc";
export const linkRelUserNoFollow = "nofollow";

export const statReferer = "source";
export const statPhrase = "phrase";
export const statScreen = "screen";

export const hashPagePref = "#!page-";

export const reDgt = /^\d+$/;
export const reBool = /^(true|false)$/i;
export const reSrc = /(?:\/file\/)?(\d{4})\/(?:(250|600|150)\/)?(\d{4})\.(jpg|svg|png)/;
export const reSrcFile = /\/file\/(\d{4})\/(?:(250|600|150)\/)?(\d{4})\.(jpg|svg|png)/;
export const reIsImage = /\.(jpg|png|svg)$/i;

const reHostKey = /([0-9a-zA-Z-]+)\.[0-9a-zA-Z-]+$/;
const reGoto = /^\/goto\/(s\/)?([^/]+)(.*)$/;

export const dirNameWebSource = "file";
export const dirNameWebPic = "web-pic";
export const dirNameWebJpg = "file"; // по задумке должно быть: web-jpg
export const dirNameGoodsPic = "goods-pic";
export const dirNameGoto = "goto";
export const dirAnonymous = "anonymous";

export const commentsPerPage = 40;

//${cssVarEditorMaxWidth}: 750px;
//${cssVarEditorFontSize}: 1.2rem;
//export const cssVarEditorMaxWidth = "--editor-max-width";
//export const cssVarEditorFontSize = "--editor-font-size";

export const cssVarLinkBaseColor = "--link-base-color";
export const cssVarBlockShopBack = "--block-shop-back";
export const cssVarBlockShopColor = "--block-shop-color";
export const cssVarBlockShopLink = "--block-shop-link";
export const cssVarBlockShopLinkDarken = "--block-shop-link-darken";
export const cssVarLabelLinkColor = "--label-link-color";

export const AttrDataDirect = "data-direct";
export const AttrDataSrc = "data-src";
export const AttrDataText = "data-text";
export const AttrDataOmit = "data-omit";
export const AttrDataType = "data-type";
export const AttrDataParam = "data-param";
export const AttrDataData = "data-data";
export const AttrDataIdf = "data-idf";
export const AttrDataLike = "data-like";
export const AttrDataLink = "data-link";
export const AttrDataCounter = "data-counter";

// noopener noreferrer sponsored ugc nofollow
export const AttrRelUGC = "ugc";
export const AttrRelNoFollow = "nofollow";
export const AttrRelSponsored = "sponsored";

export const AttrAlt = "alt";
export const AttrLoading = "loading";
export const AttrSrc = "src";
export const AttrHref = "href";
export const AttrTarget = "target";
export const AttrRel = "rel";
export const AttrAs = "as";
export const AttrId = "id";
export const AttrType = "type";
export const AttrName = "name";
export const AttrWidth = "width";
export const AttrHeight = "height";
export const AttrProperty = "property";
export const AttrContent = "content";
export const AttrHtml = "html";
export const AttrClass = "class";
export const AttrStyle = "style";
export const AttrDateTime = "datetime";

export const AttrAriaLabel = "aria-label";
export const AttrAriaCurrent = "aria-current";

export const TagPicture = "picture";
export const TagSource = "source";
export const TagMeta = "meta";
export const TagImg = "img";
export const TagLink = "link";
export const TagDiv = "div";
export const TagSpan = "span";
export const TagScript = "script";
export const TagTime = "time";
export const TagNav = "nav";
export const TagOl = "ol";
export const TagUl = "ul";
export const TagLi = "li";
export const TagBr = "br";
export const TagA = "a";
export const TagP = "p";
export const TagNoScript = "noscript";
export const TagAudio = "audio";
export const TagFigure = "figure";
export const TagFigcaption = "figcaption";
export const TagBlockquote = "blockquote";

export const ldContext = "@context";
export const ldType = "@type";
export const ldId = "@id";
export const ldItemListElement = "itemListElement";
export const ldMainEntityOfPage = "mainEntityOfPage";
export const ldMainEntity = "mainEntity";

export const ClassThumbnail = "thumbnail";
export const ClassImgR = "imgr" as const;
export const ClassImgL = "imgl" as const;

export const imageDataType = {
  image: "image" as const,
  catalog: "catalog" as const,
  slideshow: "slideshow" as const,
  quiz: "quiz" as const,
  audio: "audio" as const,
  video: "video" as const
};

export const pathUserLogin = "/on-login";
export const pathUserMenu = "/on-menu";
export const pathSiteSearch = "/search";
export const pathMailForm = "/mail-form";
export const pathAnnounce = "/announce";
export const pathSiteActivity = "/activity";
export const pathSiteComment = "/comment";

export const pathSearchPref = `${pathSiteSearch}/`;

export const pathUserAbout = "/user-about";
export const pathUserNodes = "/user-nodes";

export const pathEditorNode = "/editor-node";
export const pathEditorCatalog = "/editor-catalog";
export const pathEditorFiles = "/editor-files";

export const pathAdmin = "/admin";
export const pathAdminTree = "/tree";
export const pathAdminVerify = "/verify";
export const pathAdminLog = "/log";
export const pathAdminStat = "/stat";
export const pathAdminKeywords = "/keywords";

export const pathControl = "/control";
export const pathControlUser = `${pathControl}/user`;
export const pathControlEdit = `${pathControl}/edit`;

export const prefixLength = 10;

export const storageUserKey = "user-key";

export const testHost = "www.toybytoy.com";

export const mainHost = "www.toybytoy.com";

export function getHostName(host: string) {
  return host.startsWith("localhost") || host.startsWith("127.0.0.1") ? testHost : host;
}

export function hrefData(href: string) {
  const m = href.match(reGoto);
  return m
    ? {
      secure: !!m[1],
      host: m[2],
      path: m[3],
      hostKey: () => {
        const m2 = m[2].match(reHostKey);
        return m2 ? m2[1] : "";
      }
    }
    : null;
}

export function hrefToLink(href: string) {
  const m = href.match(reGoto);
  if (m) {
    return (m[1] ? "https://" : "http://") + m[2] + m[3];
  }
  return null;
}
